import { render, staticRenderFns } from "./administrator.vue?vue&type=template&id=d2ca1700&scoped=true"
import script from "./administrator.vue?vue&type=script&lang=js"
export * from "./administrator.vue?vue&type=script&lang=js"
import style0 from "./administrator.vue?vue&type=style&index=0&id=d2ca1700&prod&lang=scss&scoped=true"
import style1 from "./administrator.vue?vue&type=style&index=1&id=d2ca1700&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2ca1700",
  null
  
)

export default component.exports